const $$splitComponentImporter = () => import('/src/src/routes/_cms.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_cms")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});